function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["normalizedTree"];
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useReducer, useMemo, useCallback } from 'react';
import ACTIONS from './actions';
import { getLastDescendant, getNextVisibleNodeIndex, getPreviousVisibleNodeIndex, checkIsDescendant, relocateSubArray } from './helpers';
import normalizeTreeInput from '../helpers/normalizeTreeInput';
var useTreeReducer = function useTreeReducer(_ref) {
  var denormalizedTree = _ref.denormalizedTree,
    initialExpandAll = _ref.initialExpandAll,
    initialHighlightedId = _ref.initialHighlightedId,
    initialExpandedIds = _ref.initialExpandedIds,
    getIdFromNode = _ref.getIdFromNode,
    getLabelFromNode = _ref.getLabelFromNode,
    getChildrenFromNode = _ref.getChildrenFromNode,
    customReducer = _ref.customReducer;
  var _useMemo = useMemo(function () {
      return normalizeTreeInput({
        denormalizedTree: denormalizedTree,
        initialExpandAll: initialExpandAll,
        expandedIds: initialExpandedIds,
        getIdFromNode: getIdFromNode,
        getLabelFromNode: getLabelFromNode,
        getChildrenFromNode: getChildrenFromNode
      });
    }, [getChildrenFromNode, getIdFromNode, getLabelFromNode, initialExpandAll, denormalizedTree, initialExpandedIds]),
    initialNormalizedTree = _useMemo.normalizedTree,
    initialOrderedIds = _useMemo.orderedIds,
    internalExpandedIds = _useMemo.expandedIds;
  var initialTreeState = useMemo(function () {
    return {
      normalizedTree: initialNormalizedTree,
      highlightedId: initialHighlightedId,
      orderedIds: initialOrderedIds,
      expandedIds: initialExpandedIds || internalExpandedIds
    };
  }, [initialNormalizedTree, initialHighlightedId, initialOrderedIds, initialExpandedIds, internalExpandedIds]);
  var baseReducer = useCallback(function (_ref2, action) {
    var normalizedTree = _ref2.normalizedTree,
      treeState = _objectWithoutProperties(_ref2, _excluded);
    switch (action.type) {
      case ACTIONS.expandNode:
        {
          var expandedIds = _objectSpread(_objectSpread({}, treeState.expandedIds), {}, _defineProperty({}, action.payload.id, true));
          var expandedNode = normalizedTree[action.payload.id];
          var updatedNodes = {};
          var traverse = function traverse(currentNode) {
            if (currentNode.childIds && expandedIds[currentNode.id]) {
              var _currentNode$childIds;
              currentNode === null || currentNode === void 0 ? void 0 : (_currentNode$childIds = currentNode.childIds) === null || _currentNode$childIds === void 0 ? void 0 : _currentNode$childIds.forEach(function (childId) {
                var childNode = normalizedTree[childId];
                updatedNodes[childId] = _objectSpread(_objectSpread({}, childNode), {}, {
                  show: true
                });
                traverse(childNode);
              });
            }
          };
          traverse(expandedNode);
          return _objectSpread(_objectSpread({}, treeState), {}, {
            normalizedTree: _objectSpread(_objectSpread({}, normalizedTree), updatedNodes),
            expandedIds: expandedIds
          });
        }
      case ACTIONS.collapseNode:
        {
          var _expandedIds = _objectSpread({}, treeState.expandedIds);
          _expandedIds[action.payload.id] = false;
          var collapsedNode = normalizedTree[action.payload.id];
          var _updatedNodes = {};
          var _traverse = function _traverse(currentNode) {
            var _currentNode$childIds2;
            currentNode === null || currentNode === void 0 ? void 0 : (_currentNode$childIds2 = currentNode.childIds) === null || _currentNode$childIds2 === void 0 ? void 0 : _currentNode$childIds2.forEach(function (childId) {
              var childNode = normalizedTree[childId];
              _updatedNodes[childId] = _objectSpread(_objectSpread({}, childNode), {}, {
                show: false
              });
              _traverse(childNode);
            });
          };
          _traverse(collapsedNode);
          return _objectSpread(_objectSpread({}, treeState), {}, {
            normalizedTree: _objectSpread(_objectSpread({}, normalizedTree), _updatedNodes),
            expandedIds: _expandedIds
          });
        }
      case ACTIONS.collapseAllNodes:
        {
          var _updatedNodes2 = treeState.orderedIds.map(function (nodeId) {
            return _objectSpread(_objectSpread({}, normalizedTree[nodeId]), {}, {
              show: normalizedTree[nodeId].path.length === 0
            });
          }).reduce(function (accum, node) {
            accum[node.id] = node;
            return accum;
          }, {});
          return _objectSpread(_objectSpread({}, treeState), {}, {
            normalizedTree: _objectSpread(_objectSpread({}, normalizedTree), _updatedNodes2),
            expandedIds: {}
          });
        }
      case ACTIONS.highlightNode:
        {
          var updatedState = {
            highlightedId: action.payload.id
          };
          return _objectSpread(_objectSpread({
            normalizedTree: normalizedTree
          }, treeState), updatedState);
        }
      case ACTIONS.moveDown:
        {
          var nextIndex = action.payload.id ? getNextVisibleNodeIndex({
            currentNodeId: action.payload.id,
            orderedIds: treeState.orderedIds,
            normalizedTree: normalizedTree
          }) : 0;
          var _updatedState = {};
          if (nextIndex < treeState.orderedIds.length) {
            _updatedState.highlightedId = treeState.orderedIds[nextIndex];
          }
          return _objectSpread(_objectSpread({
            normalizedTree: normalizedTree
          }, treeState), _updatedState);
        }
      case ACTIONS.moveUp:
        {
          var _nextIndex = action.payload.id ? getPreviousVisibleNodeIndex({
            currentNodeId: action.payload.id,
            orderedIds: treeState.orderedIds,
            normalizedTree: normalizedTree
          }) : treeState.orderedIds.length - 1;
          var _updatedState2 = {};
          if (_nextIndex > -1) {
            _updatedState2.highlightedId = treeState.orderedIds[_nextIndex];
          }
          return _objectSpread(_objectSpread({
            normalizedTree: normalizedTree
          }, treeState), _updatedState2);
        }
      case ACTIONS.filterNodes:
        {
          if (!action.payload.ids) {
            return _objectSpread({
              normalizedTree: normalizedTree
            }, treeState);
          }
          var _expandedIds2 = {};
          var treeAllNodesHidden = treeState.orderedIds.reduce(function (newTree, id) {
            newTree[id] = _objectSpread(_objectSpread({}, normalizedTree[id]), {}, {
              show: false
            });
            return newTree;
          }, {});
          var treeFilteredNodesAndParents = action.payload.ids.reduce(function (accumNodes, id) {
            var parentNodes = normalizedTree[id].path.reduce(function (accum, parentId) {
              _expandedIds2[parentId] = true;
              accum[parentId] = _objectSpread(_objectSpread({}, normalizedTree[parentId]), {}, {
                show: true
              });
              return accum;
            }, {});
            Object.keys(parentNodes).forEach(function (key) {
              accumNodes[key] = parentNodes[key];
            });
            accumNodes[id] = _objectSpread(_objectSpread({}, normalizedTree[id]), {}, {
              show: true
            });
            return accumNodes;
          }, {});
          return _objectSpread(_objectSpread({}, treeState), {}, {
            expandedIds: _expandedIds2,
            normalizedTree: _objectSpread(_objectSpread({}, treeAllNodesHidden), treeFilteredNodesAndParents)
          });
        }
      case ACTIONS.regenerateTree:
        {
          return _objectSpread(_objectSpread({}, treeState), {}, {
            highlightedId: action.payload.highlightedId || treeState.highlightedId
          }, normalizeTreeInput({
            denormalizedTree: action.payload.denormalizedTree,
            initialExpandAll: action.payload.initialExpandAll,
            expandedIds: action.payload.expandedIds || treeState.expandedIds,
            getIdFromNode: getIdFromNode,
            getLabelFromNode: getLabelFromNode,
            getChildrenFromNode: getChildrenFromNode
          }));
        }
      case ACTIONS.moveNode:
        {
          var sourceNode = normalizedTree[action.payload.sourceId];
          var targetNode = normalizedTree[action.payload.targetId];
          var targetIsSameAsSource = action.payload.sourceId === action.payload.targetId;
          var targetIsDescendantOfSource = checkIsDescendant({
            node: sourceNode,
            potentialDescendantNode: targetNode,
            normalizedTree: normalizedTree
          });
          if (!sourceNode || !targetNode || targetIsSameAsSource || targetIsDescendantOfSource) {
            return _objectSpread({
              normalizedTree: normalizedTree
            }, treeState);
          }
          var sourceParentNode = normalizedTree[sourceNode.path[sourceNode.path.length - 1]];
          var targetParentNode = normalizedTree[targetNode.path[targetNode.path.length - 1]];

          // relocate source and all of its descendants
          var lastSourceDescendantNode = getLastDescendant({
            node: sourceNode,
            normalizedTree: normalizedTree
          });
          var _relocateSubArray = relocateSubArray({
              arr: treeState.orderedIds,
              startIndex: treeState.orderedIds.indexOf(sourceNode.id),
              endIndex: treeState.orderedIds.indexOf(lastSourceDescendantNode.id),
              targetIndex: treeState.orderedIds.indexOf(targetNode.id)
            }),
            _relocateSubArray2 = _slicedToArray(_relocateSubArray, 2),
            updatedOrderedIds = _relocateSubArray2[0],
            sourceIds = _relocateSubArray2[1];
          var _updatedNodes3 = _defineProperty({}, sourceNode.id, sourceNode);
          // update path of all descendants to point to new target parent
          var newPrePath = targetNode.path;
          sourceIds.forEach(function (id) {
            if (id === sourceNode.id) {
              _updatedNodes3[sourceNode.id].path = newPrePath;
            } else {
              _updatedNodes3[id] = normalizedTree[id];
              _updatedNodes3[id].path = [].concat(_toConsumableArray(newPrePath), _toConsumableArray(_updatedNodes3[id].path.slice(_updatedNodes3[id].path.indexOf(sourceNode.id))));
            }
          });

          // update old parent of source's childIds
          if (sourceParentNode) {
            _updatedNodes3[sourceParentNode.id] = sourceParentNode;
            var indexOfSourceInSourceParentChildIds = _updatedNodes3[sourceParentNode.id].childIds.indexOf(sourceNode.id);
            _updatedNodes3[sourceParentNode.id].childIds = [].concat(_toConsumableArray(_updatedNodes3[sourceParentNode.id].childIds.slice(0, indexOfSourceInSourceParentChildIds)), _toConsumableArray(_updatedNodes3[sourceParentNode.id].childIds.slice(indexOfSourceInSourceParentChildIds + 1)));
          }
          // update new parent of source's childIds
          if (targetParentNode) {
            _updatedNodes3[targetParentNode.id] = sourceParentNode;
            var indexOfTargetInTargetParentChildIds = _updatedNodes3[targetParentNode.id].childIds.indexOf(targetNode.id);
            _updatedNodes3[targetParentNode.id] = targetParentNode;
            _updatedNodes3[targetParentNode.id].childIds = [].concat(_toConsumableArray(_updatedNodes3[targetParentNode.id].childIds.slice(0, indexOfTargetInTargetParentChildIds)), [sourceNode.id], _toConsumableArray(_updatedNodes3[targetParentNode.id].childIds.slice(indexOfTargetInTargetParentChildIds)));
          }
          return _objectSpread(_objectSpread({}, treeState), {}, {
            orderedIds: updatedOrderedIds,
            normalizedTree: _objectSpread(_objectSpread({}, normalizedTree), _updatedNodes3)
          });
        }
      case ACTIONS.addChildNodes:
        {
          var targetId = action.payload.targetId;
          var newChildNodes = normalizeTreeInput({
            denormalizedTree: action.payload.newChildNodes,
            expandedIds: action.payload.newChildExpandedIds,
            getIdFromNode: getIdFromNode,
            getLabelFromNode: getLabelFromNode,
            getChildrenFromNode: getChildrenFromNode
          });
          var prePath = [].concat(_toConsumableArray(normalizedTree[targetId].path), [targetId]);
          var newChildIds = [];
          Object.entries(newChildNodes.normalizedTree).forEach(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
              id = _ref4[0],
              el = _ref4[1];
            if (!el.path.length) {
              newChildIds.push(id);
            }
            el.path = [].concat(_toConsumableArray(prePath), _toConsumableArray(el.path));
          });
          normalizedTree[targetId].childIds = newChildIds;
          var loc = treeState.orderedIds.indexOf(targetId);
          var _updatedOrderedIds = [].concat(_toConsumableArray(treeState.orderedIds.slice(0, loc + 1)), _toConsumableArray(newChildNodes.orderedIds), _toConsumableArray(treeState.orderedIds.slice(loc + 1)));
          return _objectSpread(_objectSpread({}, treeState), {}, {
            orderedIds: _updatedOrderedIds,
            expandedIds: _objectSpread(_objectSpread({}, treeState.expandedIds), newChildNodes.expandedIds),
            normalizedTree: _objectSpread(_objectSpread({}, normalizedTree), newChildNodes.normalizedTree)
          });
        }
      default:
        {
          if (customReducer) {
            return _objectSpread({
              normalizedTree: normalizedTree
            }, treeState);
          } else {
            throw new Error("Action not implemented: ".concat(JSON.stringify(action), "\n\tIf you need to extend the tree state with custom actions you can pass a 'reducer' function to useTree\n          "));
          }
        }
    }
  }, [customReducer, getChildrenFromNode, getIdFromNode, getLabelFromNode]);
  var compositeReducer = useCallback(function (treeState, action) {
    if (customReducer) {
      return customReducer(baseReducer(treeState, action), action);
    }
    return baseReducer(treeState, action);
  }, [customReducer, baseReducer]);
  var _useReducer = useReducer(compositeReducer, initialTreeState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  return {
    state: state,
    dispatch: dispatch
  };
};
export default useTreeReducer;
//# sourceMappingURL=useTreeReducer.js.map